import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form, Row, Col } from "react-bootstrap";

//UI components
import FormFieldCurrency from "../../../ui/FormFieldCurrency";
import FormField from "../../../ui/FormField";
import ErrorMessage from "../../../ui/ErrorMessage";

//Validation schema
import formEditClaniceFinanceRealiziranoSchema from "../../../../config/formEditClaniceFinanceRealizirano";

//API calls
import { useEditRealiziraneVrednostiProjektaClanice } from "../../../../services/ProjectDetails/financeAPI";

const EditFormClaniceRealizirano = ({ clanica, setIsEditing }) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditClaniceFinanceRealiziranoSchema, []);

  //PUT edit realizirane vrednosti clanice
  const {
    mutate: editRealiziraneVrednostiClanice,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditRealiziraneVrednostiProjektaClanice(id);

  const {
    handleSubmit,
    register,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      realiziranaVrednost: clanica?.realiziranaVrednost,
      realiziranaLastnaVrednost: clanica?.realiziranaLastnaVrednost,
      realiziranaVrednostViri: clanica?.realiziranaVrednostViri,
      realiziranaObseg: clanica?.realiziranaObseg,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      clanicaID: clanica.clanicaID,
      realiziranaVrednost: data?.realiziranaVrednost,
      realiziranaLastnaVrednost: data?.realiziranaLastnaVrednost,
      realiziranaVrednostViri: data?.realiziranaVrednostViri,
      realiziranaObseg: data?.realiziranaObseg,
    };

    editRealiziraneVrednostiClanice(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md={6}>
          <FormFieldCurrency
            label="Vrednost projekta"
            name="realiziranaVrednost"
            control={control}
            validationError={errors.realiziranaVrednost?.message}
          />
          <FormFieldCurrency
            label="Lastno sofinanciranje"
            name="realiziranaLastnaVrednost"
            control={control}
            validationError={errors.realiziranaLastnaVrednost?.message}
          />
        </Col>
        <Col md={6}>
          <FormFieldCurrency
            label="Sofinanciranje iz projektnega vira"
            name="realiziranaVrednostViri"
            control={control}
            validationError={errors.realiziranaVrednostViri?.message}
          />
          <FormField
            label="Obseg zaposlitev (FTE)"
            formControlType="number"
            register={register("realiziranaObseg", { valueAsNumber: true })}
            validationError={errors.realiziranaObseg?.message}
            min={0}
            step={0.1}
          />
        </Col>
      </Row>
      <button
        type="submit"
        className="btn btn-primary mt-3"
        disabled={!isDirty || isPendingEdit}
      >
        {isPendingEdit ? "Shranjevanje..." : "Shrani"}
      </button>
      <button
        type="button"
        className="btn btn-secondary mt-3 ms-2"
        onClick={() => setIsEditing(false)}
      >
        Prekliči
      </button>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default EditFormClaniceRealizirano;
